import { AuthenticationPage } from "Styles/pilotAuthentication.style";
import React, { useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { EmailField } from "./ForgotPassword.style";
import "../../../Styles/authentication.css";
import "../../../Styles/typography.css";

import { ReactComponent as HeaderLogo } from "../../../Assets/Images/LandingPage/subjects-master-logo.svg";
import { ReactComponent as ButtonArrow } from "../../../Assets/Images/Button/btn_arrow.svg";
import { ReactComponent as FacebookIcon } from "../../../Assets/Images/Header/Facebook.svg";
import { ReactComponent as InstaIcon } from "../../../Assets/Images/Header/Instagram.svg";
import { ReactComponent as TiktokIcon } from "../../../Assets/Images/Header/TikTok.svg";
import { SOCIAL_MEDIA_LINKS } from "Helpers";
import MobileHeader from "Components/Header/MobileHeader";
import { InputLabel, Box } from "@material-ui/core";

// FORM VALIDATION
import { useFormik } from "formik";
import * as Yup from "yup";

// CONST
import { Api, CODES, URL_LOGIN, generateValidationSchema, URL_GENERAL_DASHBOARD } from "Helpers";
import { showToast } from "Redux/General/Actions";

// SOUNDS
import CustomButton from "Components/Commons/CustomButton/CustomButton";

function Login() {
	const [isLoading, setIsLoading] = useState(false);

	const isLoggedIn = useSelector((state) => state.Auth.isLoggedIn);
	const dispatch = useDispatch();

	const navigate = useNavigate();

	useEffect(() => {
		checkIfAlreadyLoggedIn();
		//eslint-disable-next-line
	}, []);

	const formik = useFormik({
		initialValues: {
			email: "",
		},
		validationSchema: Yup.object({
			email: Yup.string().required("*Please enter your email address.").email("Ex user@mail.com"),
		}),
		onSubmit: (values) => {
			sendEmail(values);
		},
	});

	function checkIfAlreadyLoggedIn() {
		if (isLoggedIn) navigate(URL_GENERAL_DASHBOARD);
	}

	function sendEmail(values) {
		setIsLoading(true);
		let data = new FormData();
		data.append("email", values.email);
		new Api()
			.post("user/forgotPassword", { data, returnError: true })
			.then(async (response) => {
				setIsLoading(false);
				dispatch(showToast("Email Sent !! \n Please check your email"));
				navigate(URL_LOGIN);
			})
			.catch((error) => {
				if (error.status === CODES.UNAUTHORIZED) dispatch(showToast(error.data.message || "invalid email "));
				setIsLoading(false);
			});
	}


	return (
		<AuthenticationPage>
			<div className="login-regi-wrapper">
				<div className="auth-wrap-left">
					<div className="auth_wrap_logo">
						<div className="auth_wrap_logo">
							<MobileHeader></MobileHeader>
							<Link to="/" className="desktop_logo_login">
								<HeaderLogo></HeaderLogo>
							</Link>
						</div>
					</div>
					<div className="auth_wrap_left_in">
						<h1>
							Welcome to <br /> <span className="redfont">Subjects Master</span>
						</h1>
						<p>
							Oops! Forgot your password? Don’t worry—you can easily reset it and get back to your learning adventure. Just enter your email, and we’ll send you step-by-step instructions to
							unlock your account so you can continue exploring games, challenges, and activities with Subjects Master.
						</p>
					</div>
				</div>
				<div className="auth_wrap_right">
					<div className="">
						<div className="menu_other_buttons">
							<div className="social_handles">
								<ul>
									<li>
										<a href={SOCIAL_MEDIA_LINKS.FACEBOOK} target="_blank" rel="noopener noreferrer">
											<FacebookIcon />
										</a>
									</li>
									<li>
										<a href={SOCIAL_MEDIA_LINKS.INSTAGRAM} target="_blank" rel="noopener noreferrer">
											<InstaIcon />
										</a>
									</li>
									<li>
										<a href={SOCIAL_MEDIA_LINKS.TIKTOK} target="_blank" rel="noopener noreferrer">
											<TiktokIcon />
										</a>
									</li>
								</ul>
							</div>

							<div className="portal_login_link">
								<Link to="/teacher/login">Portal Login</Link>
							</div>
							<div className="logins_btn">
								<Link to="/login" className="customs_btn">
									Login{" "}
									<span>
										<ButtonArrow />
									</span>
								</Link>
							</div>
						</div>
					</div>
					<div className="auth_right_inner">
						<div className="auth_right_head">
							<h2>Forgot Password?</h2>
							<h4 className="redfont">Oops! Let’s Unlock Your Account.</h4>
						</div>
						<form onSubmit={formik.handleSubmit} validationSchema={validationSchema}>
							<Box className="content">
								<Box className="header">
									<InputLabel className="header"></InputLabel>
								</Box>
								<Box>
									<Box className="flex-column-parent">
										<Box className="flex-column field_wrapper">
											<Box component="Box" sx={{ display: "inline" }} className="text">
												<InputLabel className="text">Email address</InputLabel>
											</Box>

											<EmailField
												id="email"
												name="email"
												className="login"
												autoComplete="false"
												onBlur={formik.handleBlur}
												onChange={formik.handleChange}
												defaultValue={formik.values.email}
												placeholder="Enter email address"
												helpertext={formik.touched.email && formik.errors.email}
											/>
											<Box component="div" sx={{ display: "inline", height: "10px" }} className="validation-error text">
												{formik.touched.email && formik.errors.email ? formik.errors.email : ""}
											</Box>
										</Box>
									</Box>
								</Box>
								<div className="login_btn_divs">
									<Box className="login-button-parent">
										<CustomButton text={isLoading ? "Loading..." : "Request a new Password"} className="button" type="submit" isLoading={isLoading} />
									</Box>
								</div>
							</Box>
						</form>
					</div>
				</div>
			</div>
		</AuthenticationPage>
	);
}

export default Login;

const inputs = [
	{
		label: "Email",
		name: "email",
		validation: { required: true, email: true },
	},
];

const validationSchema = generateValidationSchema(inputs);
